var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.729,
    height: 200,
    viewBox: "0 0 200.729 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 24.194,
    y: 39.046,
    width: 90.506,
    height: 105.716,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 42.994,
    y: 21.691,
    width: 131.225,
    height: 128.9,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 69.128,
    y: 100.802,
    width: 75.878,
    height: 71.46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "g"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 124.631,
    y: 110.457,
    width: 63.278,
    height: 62.908,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 12.821,
    y: 105.03,
    width: 56.99,
    height: 67.446,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    x: 95.188,
    y: 18.271,
    width: 52.057,
    height: 48.971,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "m"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "m"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 96.59,
    y: 133.374,
    width: 48.309,
    height: 47.385,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: 73.831,
    y: 134.483,
    width: 42.976,
    height: 45.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "q"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    x: 127.087,
    y: 24.286,
    width: 40.144,
    height: 37.686,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "s"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "s"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 24.184,
    y: 40.658,
    width: 40.085,
    height: 36.925,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "u"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "u"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    x: 129.486,
    y: 33.585,
    width: 39.098,
    height: 36.637,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "w"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "w"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "x",
    x: 122.614,
    y: 17.1,
    width: 35.403,
    height: 39.158,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "y"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "y"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    x: 24.156,
    y: 49.106,
    width: 38.609,
    height: 36.841,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "aa"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "aa"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ab",
    x: 32.167,
    y: 33.115,
    width: 35.908,
    height: 38.812,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "ac"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "ac"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.771)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40.771)",
    stroke: "#fff",
    strokeWidth: 4,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.365,
    cy: 100,
    rx: 100.365,
    ry: 100,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.365,
    cy: 100,
    rx: 98.365,
    ry: 98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.95 32.1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.708-369.39c.035,4.19-2.474,7.7-6.739,9.383-.675.268-1.046.382-.528,1.253A9.882,9.882,0,0,1,655-343.9c-.8.278-1.067.46-.689,1.356a9.9,9.9,0,0,1-6.21,13.531c-1.182.4-1.332.682-.768,1.831,3.462,7.085-2.048,13.9-8.32,14.733a14.885,14.885,0,0,1-7.763-1.142c-5.564-2.28-11.189-4.418-16.71-6.8-4.329-1.87-7.1-5.139-7.327-10.022-.2-4.265,1.884-7.359,5.589-9.344.9-.485,1.253-.735.575-1.8-3.559-5.6-1.21-12.421,5.054-14.79.967-.364,1.32-.629.881-1.753a9.808,9.808,0,0,1,5.757-13.024c1.046-.407,1.107-.7.568-1.656a10.217,10.217,0,0,1,8.676-15.255,14.139,14.139,0,0,1,5.475.8q10.022,3.683,20.044,7.373a12.281,12.281,0,0,1,6.289,5.068A9.742,9.742,0,0,1,667.708-369.39Zm-10.968,5.268a7.4,7.4,0,0,0,1.01-.007,5.691,5.691,0,0,0,4.729-3.394c.871-1.9.328-3.612-.824-5.218a7.772,7.772,0,0,0-3.847-2.691q-9.589-3.517-19.159-7.074a9.379,9.379,0,0,0-4.294-.6,5.618,5.618,0,0,0-4.868,3.394,4.961,4.961,0,0,0,.992,5.432,7.155,7.155,0,0,0,3.073,2.238q9.953,3.678,19.9,7.359A7.341,7.341,0,0,0,656.74-364.122Zm-12.481,30.876a10.182,10.182,0,0,0,1.32-.082A5.656,5.656,0,0,0,650-336.743a4.911,4.911,0,0,0-.932-5.2,8.182,8.182,0,0,0-3.758-2.62q-9.631-3.56-19.269-7.12a9.016,9.016,0,0,0-3.766-.6c-3.847.257-6.414,3.191-5.539,6.5a6.9,6.9,0,0,0,4.63,4.747q9.749,3.625,19.519,7.21A8.935,8.935,0,0,0,644.259-333.245Zm-20.79-28.628a5.961,5.961,0,0,0,4.008,5.546q10.67,4.021,21.358,8a6.648,6.648,0,0,0,6.064-.9,4.888,4.888,0,0,0,1.617-6.646,8.009,8.009,0,0,0-4.561-3.626q-7.593-2.795-15.18-5.593A41.736,41.736,0,0,0,631-367.038C627.063-367.852,623.476-365.385,623.469-361.873Zm-4.654,25.526c-4.09-.043-7.006,2.706-6.717,6.1.232,2.72,1.974,4.426,4.333,5.411,5.875,2.452,11.785,4.818,17.71,7.152a7.353,7.353,0,0,0,7.406-1.046,4.887,4.887,0,0,0,1.785-5.432,7.291,7.291,0,0,0-4.676-4.725q-8.176-3.309-16.357-6.606A10.941,10.941,0,0,0,618.815-336.347Z",
    transform: "translate(-568.01 442.09)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.124-360.81c-.486,1.774.539,2.8,1.681,3.979,4.608,4.751,5.528,11.029,2.591,17.168a1.7,1.7,0,0,0,.314,2.184A12.147,12.147,0,0,1,712-322.7a2.447,2.447,0,0,0-.168,2.47,16.325,16.325,0,0,1,1.474,8.005,9.765,9.765,0,0,1-6.77,8.52c-5.5,1.667-16.939,7.829-22.446,9.485-1.035.314-1.349.018-1.417-.96-.061-.924-.182-1.849-.328-2.763s.528-1,1.113-1.171c5.011-1.452,15.926-7.519,20.937-8.975a5.17,5.17,0,0,0,4.14-4.915,11.322,11.322,0,0,0-1.121-5.272.723.723,0,0,0-1.067-.428,10.222,10.222,0,0,1-1.382.475,2.46,2.46,0,0,1-2.829-1.424,2.381,2.381,0,0,1,1.1-3.069,22.576,22.576,0,0,1,2.341-.932,5.5,5.5,0,0,0,3.513-5.853,10.182,10.182,0,0,0-1.813-4.515,1.354,1.354,0,0,0-1.806-.571,32.877,32.877,0,0,1-3.3,1,2.391,2.391,0,0,1-3.07-1.581,2.412,2.412,0,0,1,1.659-3.037,6.693,6.693,0,0,1,1.524-.457c2.12-.268,3.13-1.667,3.908-3.487,1.875-4.369,1.15-8.495-2.1-11.557a1.867,1.867,0,0,0-2.142-.517c-1.288.464-2.616.814-3.933,1.2-1.834.542-3.062.022-3.558-1.488-.449-1.374.325-2.57,2.063-3.13,1.22-.393,2.441-.785,3.679-1.118a1.456,1.456,0,0,0,1.2-1.517c.289-5.653-2.948-9.255-8.641-9.551a19.956,19.956,0,0,0-7.452.985c-8.68,2.919-23,8.251-31.676,11.2-1.253.424-1.913.293-2.137-1.075a3.8,3.8,0,0,0-.365-1c-.921-1.917-1.174-1.824,1.235-2.634,5.115-1.717,15.858-5.91,20.965-7.649.385-.129,1.01-.078,1.031-.628.014-.418-.539-.536-.864-.739-4.458-2.805-8.944-5.564-13.377-8.405-1.656-1.06-3.533-1.107-5.335-1.431-11.968-2.156-23.942-4.237-35.917-6.346-1.331-.232-1.567-.029-1.553,1.335.018,2.063,2.01,9.558,3.216,11.207.553.753.532,1.132-.514,1.267a13.31,13.31,0,0,0-2.7.649,1.213,1.213,0,0,1-1.713-.678c-2.066-3.776-3.683-13.384-2.534-17.474a2.353,2.353,0,0,1,2.888-1.7q21.682,3.8,43.369,7.613a7.076,7.076,0,0,1,2.584.974c5.764,3.637,11.568,7.213,17.307,10.889a3.464,3.464,0,0,0,3.455.379,22.909,22.909,0,0,1,12.891-1.228C701.9-373.07,705.9-368.444,706.12-362,706.135-361.606,706.124-361.206,706.124-360.81Z",
    transform: "translate(-554.7 429.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.8-356.492a13.48,13.48,0,0,1-3.854,9.622c-5.593,5.6-11.289,11.107-16.975,16.618-1.574,1.524-2.673,1.464-4.229-.057-5.5-5.379-11.061-10.711-16.482-16.175-4.183-4.208-5.454-9.279-3.316-14.872,2.081-5.439,6.242-8.423,12.017-9.1a13.422,13.422,0,0,1,8.773,1.9,1.939,1.939,0,0,0,2.292-.007,14.439,14.439,0,0,1,21.643,10.236A18.093,18.093,0,0,1,665.8-356.492Zm-4.921-.157a9.285,9.285,0,0,0-.218-2.027,9.669,9.669,0,0,0-15.169-5.054c-2.545,1.913-2.634,1.909-5.154.054a9.274,9.274,0,0,0-10.49-.849c-5.885,3.173-6.749,10.126-1.977,14.844,4.654,4.608,9.383,9.141,14.034,13.755.81.807,1.267.7,2.023-.039,4.633-4.568,9.319-9.08,13.977-13.623A9.068,9.068,0,0,0,660.874-356.649Z",
    transform: "translate(-535.79 486.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.842-337.351a2.424,2.424,0,0,1-1.392,2.127,2.318,2.318,0,0,1-2.791-.564q-2.639-2.8-5.243-5.632c-5.778-6.285-17.257-17.727-23.028-24.012-1.224-1.331-1.125-1.249.571-1.97,2.513-1.07,4.044-.339,5.825,1.685,6.221,7.07,18.41,19.065,24.791,25.992A3.491,3.491,0,0,1,668.842-337.351Z",
    transform: "translate(-495.93 493.35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.023-331.967c-1.56,0-2.634-2.077-1.6-3.8,1.164-1.928,2.438-3.794,3.676-5.679,4.586-6.988,13.525-20.042,18.073-27.055a1.529,1.529,0,0,1,2.266-.671c3.155,1.32,3.162,1.278,1.3,4.122-5.514,8.391-15.349,22.869-20.843,31.271A3.272,3.272,0,0,1,606.023-331.967Z",
    transform: "translate(-576.2 489.44)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M649.3-383.411a18.25,18.25,0,0,1-1.509,6.635,3.639,3.639,0,0,1-5.293,1.067c-.66-.6-.135-1.039.111-1.5,1.62-3.03,2.349-6.175,1.281-9.569-.51-1.624-.5-1.631-2.049-.85-3.077,1.553-6.16,3.095-9.223,4.679a1.689,1.689,0,0,1-1.955-.072c-.942-.66-1.927-1.249-2.909-1.852-.628-.385-.736-.714.014-1.092,5.093-2.559,10.168-5.154,15.276-7.684a2.55,2.55,0,0,1,3.448,1.074A17.226,17.226,0,0,1,649.3-383.411Z",
    transform: "translate(-517.05 427.23)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630.232-361.468a2.278,2.278,0,0,1,1.677.821c2.181,2.191,11.077,10.161,13.229,12.378a2.427,2.427,0,0,1,.164,3.451,2.422,2.422,0,0,1-3.458.01c-2.316-2.241-11.28-10.329-13.529-12.638a2.291,2.291,0,0,1-.418-2.706A2.325,2.325,0,0,1,630.232-361.468Z",
    transform: "translate(-516.05 509.85)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.723-345.445c-1.816-.014-3.094-1.806-2.245-3.255,1.756-3,7.074-9.147,8.952-12.077.314-.489.681-.5,1.084-.1.782.771,1.563,1.553,2.36,2.313.453.428.357.828.054,1.288-1.6,2.427-6.551,8.126-8.146,10.557A2.657,2.657,0,0,1,623.723-345.445Z",
    transform: "translate(-532.38 510.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M638.6-384.586a2.344,2.344,0,0,1-2.156-1.57,2.128,2.128,0,0,1,.792-2.706,38.63,38.63,0,0,1,6.083-3.237,2.063,2.063,0,0,1,2.562.856,2.184,2.184,0,0,1,.086,2.72C645.388-387.655,639.716-384.6,638.6-384.586Z",
    transform: "translate(-494.16 431.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M609.778-387.641a10.1,10.1,0,0,1,1.028.289c1.56.625,3.123,1.242,4.665,1.909s2.162,1.981,1.624,3.287a2.462,2.462,0,0,1-3.348,1.218c-1.734-.653-3.462-1.346-5.143-2.128a2.2,2.2,0,0,1-1.3-2.748A2.467,2.467,0,0,1,609.778-387.641Z",
    transform: "translate(-568.02 443.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.553-389.666c1.849.721,3.991,1.231,5.718,2.577a2.05,2.05,0,0,1,.39,2.777,2.1,2.1,0,0,1-2.555,1.174,37.265,37.265,0,0,1-5.011-2.059,2.11,2.11,0,0,1-1.067-2.606A2.587,2.587,0,0,1,639.553-389.666Z",
    transform: "translate(-492.44 438.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M634.952-388.286c.16-1.035.328-2.577.649-4.086a2.388,2.388,0,0,1,2.791-1.863,2.462,2.462,0,0,1,1.938,2.762c-.189,1.4-.407,2.8-.682,4.183a2.339,2.339,0,0,1-2.68,2.141C635.659-385.3,634.934-386.248,634.952-388.286Z",
    transform: "translate(-497.34 426.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.8-382.813a2.343,2.343,0,0,1-1,1.842,19.252,19.252,0,0,1-4.391,2.4,2.323,2.323,0,0,1-2.923-1.1,2.243,2.243,0,0,1,.746-3.03,31.371,31.371,0,0,1,4.272-2.356A2.388,2.388,0,0,1,615.8-382.813Z",
    transform: "translate(-568.04 449.36)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -27.82, -32.1)",
    filter: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.151-380.986a2.252,2.252,0,0,1-2.462-1.588c-.454-1.428-.871-2.873-1.192-4.336a2.331,2.331,0,0,1,1.681-2.777,2.264,2.264,0,0,1,2.873,1.46,34.545,34.545,0,0,1,1.253,4.59A2.254,2.254,0,0,1,613.151-380.986Z",
    transform: "translate(-562.27 437.91)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriend);
export default __webpack_public_path__ + "static/media/Friend.478d8b595b0eadec9850fed1ed56d683.svg";
export { ForwardRef as ReactComponent };